import {ref} from 'vue';

export default {
    install: (app, options) => {
        const profileCompany = ref(null);
        const profileCompanyChannel = ref(null);
        const distributor = ref(null);
        const manufacturer = ref(null);

        const loadProfileCompany = () => {
            window.lazy_axios.get('/dashboard/profile/company')
                .then((response) => {
                    if (response.data.company) {
                        profileCompany.value = response.data.company;

                        if (window.Echo) {
                            profileCompanyChannel.value = window.Echo.private(`companies.${response.data.company.id}`);
                        }
                    }
                    if (response.data.distributor) {
                        distributor.value = response.data.distributor;
                    }
                    if (response.data.manufacturer) {
                        manufacturer.value = response.data.manufacturer;
                    }
                });
        };

        const resetAll = () => {
            profileCompany.value = null;
        };

        app.provide('profileCompany', profileCompany);
        app.provide('loadProfileCompany', loadProfileCompany);

        app.provide('profileCompanyProvider', {
            profileCompany,
            profileCompanyChannel,
            distributor,
            manufacturer,
            loadProfileCompany,
            resetAll,
        });
    },
}
